module.exports = __webpack_public_path__ + "static/media/step-indicator-3.0bcc4af9.svg";